"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Concept = exports.Scheduled = exports.StyledHeadlineLink = exports.Category = exports.StyledLink = exports.LinkWrapper = exports.Content = exports.Headline = exports.PostTimestamp = exports.Text = exports.Image = exports.StyledImageLink = exports.StyledExcerpt = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const get_cms_asset_1 = __importDefault(require("@src/helpers/get-cms-asset"));
const excerpt_html_1 = __importDefault(require("excerpt-html"));
const elements_1 = require("@src/components/elements");
const timestamp_1 = __importDefault(require("@src/components/modules/global/timestamp"));
const react_intl_1 = require("react-intl");
exports.StyledExcerpt = styled_components_1.default.article `
	border: 1px solid #e8e0da;
	background: #fff;
	border-radius: 0.3rem;
	overflow: hidden;
	display: flex;
	margin-bottom: 1.875rem;
	flex-direction: column;
	width: 100%;
	${(0, styled_breakpoints_1.up)('md')} {
		flex-direction: row;
	}
`;
exports.StyledImageLink = (0, styled_components_1.default)(elements_1.Link) `
	display: block;
	padding-top: 0;
	min-height: 250px;
	max-height: 400px;
	height: 75vw;
	width: auto;
	${(0, styled_breakpoints_1.up)('md')} {
		width: 340px;
		height: auto;
		min-height: initial;
		max-height: initial;
	}
`;
exports.Image = styled_components_1.default.span `
	height: 100%;
	width: 100%;
	display: block;
	position: relative;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: top center;
	background-image: url(${props => (0, get_cms_asset_1.default)(props.url)});

	@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
		only screen and (min--moz-device-pixel-ratio: 1.3),
		only screen and (-o-min-device-pixel-ratio: 1.3/1),
		only screen and (min-resolution: 144dpi),
		only screen and (min-resolution: 1.5dppx) {
		background-image: url(${props => (0, get_cms_asset_1.default)(props.url, 'preview_2x')});
	}
`;
exports.Text = styled_components_1.default.div `
	padding: 2.25rem;
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 340px;
`;
exports.PostTimestamp = styled_components_1.default.time `
	font-weight: bold;
	text-transform: uppercase;
	color: #6c6c6c;
`;
exports.Headline = styled_components_1.default.h2 `
	font-weight: bold;
	text-transform: uppercase;
	color: ${props => props.theme.color.brand1};
	font-size: 2rem;
	margin: 0.4rem 0;
`;
exports.Content = styled_components_1.default.div `
	font-size: 1.1rem;
`;
exports.LinkWrapper = styled_components_1.default.div `
	display: flex;
	flex: 1;
	margin-top: 0.8rem;
	flex-direction: column-reverse;
	align-items: flex-start;
	align-self: flex-end;
	justify-content: space-between;
	width: 100%;
	${(0, styled_breakpoints_1.up)('md')} {
		flex-direction: row;
		align-items: flex-end;
		align-self: flex-end;
		justify-content: space-between;
	}
`;
exports.StyledLink = (0, styled_components_1.default)(elements_1.Link) `
	display: block;
	font-size: 1.4rem;
	text-decoration: underline;
	text-align: right;
`;
exports.Category = styled_components_1.default.span `
	display: block;
	font-size: 1em;
	color: ${props => props.theme.color.gray5};
	text-transform: uppercase;
	text-align: left;
	margin-top: 2em;
	margin-bottom: 0.3em;
	${(0, styled_breakpoints_1.up)('md')} {
		margin-top: 0;
	}
`;
exports.StyledHeadlineLink = (0, styled_components_1.default)(elements_1.Link) `
	display: inline-block;
	text-decoration: uppercase;
	&:hover {
		text-decoration: none;
	}
`;
exports.Scheduled = styled_components_1.default.span `
	color: ${props => props.theme.color.white};
	background: ${props => props.theme.color.warning};
	padding: 0 0.5em;
	display: block;
	border-radius: 3px;
	${(0, styled_breakpoints_1.up)('md')} {
		display: inline-block;
		margin: 0 0 0 1em;
	}
`;
exports.Concept = styled_components_1.default.span `
	color: ${props => props.theme.color.white};
	background: ${props => props.theme.color.success};
	display: block;
	padding: 0 0.5em;
	border-radius: 3px;
	${(0, styled_breakpoints_1.up)('md')} {
		display: inline-block;
		margin: 0 0 0 1em;
	}
`;
const Excerpt = ({ post }) => {
    const excerpt = (0, excerpt_html_1.default)(post.content, { pruneLength: 520 });
    return ((0, jsx_runtime_1.jsxs)(exports.StyledExcerpt, { children: [(0, jsx_runtime_1.jsx)(exports.StyledImageLink, { to: `/magazin/${post.slug}`, children: (0, jsx_runtime_1.jsx)(exports.Image, { url: post.coverImage }) }), (0, jsx_runtime_1.jsxs)(exports.Text, { children: [(0, jsx_runtime_1.jsxs)(exports.PostTimestamp, { children: [(0, jsx_runtime_1.jsx)(timestamp_1.default, { value: post.date, type: "humanized" }), post.scheduled && ((0, jsx_runtime_1.jsx)(exports.Scheduled, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "magazine.scheduled" }) })), !post.published && ((0, jsx_runtime_1.jsx)(exports.Concept, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "magazine.concept" }) }))] }), (0, jsx_runtime_1.jsx)(exports.StyledHeadlineLink, { to: `/magazin/${post.slug}`, children: (0, jsx_runtime_1.jsx)(elements_1.Title, { level: 2, type: "secondary", align: "left", children: post.title }) }), (0, jsx_runtime_1.jsx)(exports.Content, { children: excerpt }), (0, jsx_runtime_1.jsxs)(exports.LinkWrapper, { children: [(0, jsx_runtime_1.jsx)(exports.Category, { children: post.category }), (0, jsx_runtime_1.jsx)(exports.StyledLink, { to: `/magazin/${post.slug}`, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "magazine.full_article" }) })] })] })] }));
};
exports.default = Excerpt;
